import { render, staticRenderFns } from "./ExpensesTable.vue?vue&type=template&id=c4b1df2e&scoped=true"
import script from "./ExpensesTable.vue?vue&type=script&lang=js"
export * from "./ExpensesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b1df2e",
  null
  
)

export default component.exports